<template lang="">
  <div class="el-login-footer card-body p-0 px-3 d-flex">
    <div
      class="copyright col-12 text-center pb-1"
      style="margin-block-start: auto"
    >
      {{ $t("label.copyRight") }}
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        data-webtrekkactionname="externalLinks"
        style="text-decoration: underline"
        class="text-dark ml-2"
      >
        沪ICP备 10028897号-44 </a
      >,
      <img src="/img/beian_icon.png" class="record_icon" />
      沪公网安备案31011002005663
      <router-link
        :to="{ name: routeName.IMPRINT, params: { language: language } }"
        target="_blank"
        class="text-dark ml-2"
      >
        {{ $t("label.imprint") }}</router-link
      >
      <router-link
        :to="{ name: routeName.TERMS_OF_USE, params: { language: language } }"
        target="_blank"
        class="text-dark ml-2"
      >
        {{ $t("label.termsOfUse") }}</router-link
      >
      <router-link
        :to="{
          name: routeName.DATA_PROTECTION_STATEMENT,
          params: { language: language },
        }"
        target="_blank"
        class="text-dark ml-2"
      >
        {{ $t("label.dataProtectionStatement") }}</router-link
      >
      <router-link
        :to="{ name: routeName.COOKIES, params: { language: language } }"
        target="_blank"
        class="text-dark ml-2"
      >
        {{ $t("label.cookies") }}</router-link
      >
    </div>
  </div>
</template>
<script>
import { ROUTE_NAME } from "@/core/constants";

export default {
  name: "ContentFooter",
  data: () => ({
    routeName: ROUTE_NAME,
  }),
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
};
</script>
<style lang="scss">
.el-login-footer {
  bottom: 0;
  min-width: 100%;
  color: #000;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
  display: table-cell;
  vertical-align: middle;
}
</style>
